module.exports = __webpack_public_path__ + "ed6e134687296a2c77e9c0d9d4a95c0e.svg";